/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUnitCostLogRequest } from '../../models/create-unit-cost-log-request';
import { UnitCostLogDto } from '../../models/unit-cost-log-dto';

export interface CreateUnitCostLog$Params {
      body: CreateUnitCostLogRequest
}

export function createUnitCostLog(http: HttpClient, rootUrl: string, params: CreateUnitCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostLogDto>> {
  const rb = new RequestBuilder(rootUrl, createUnitCostLog.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitCostLogDto>;
    })
  );
}

createUnitCostLog.PATH = '/v0/unitCostLogs/{id}';
